var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"提示","visible":_vm.dialogVisible,"before-close":_vm.handleClose,"append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('p',{staticClass:"tip"},[_vm._v(_vm._s(_vm.text))]),_c('el-progress',{attrs:{"percentage":_vm.schedule}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }